import { Modal, Button } from "antd";
import styled from "styled-components";
import useModal from "../../hooks/useModal";
import { showError, showSuccess } from "infra/helpers/alerta";
import useDeleteJobs from "../../hooks/useDeleteJobs";

interface DeleteModalProps {
  refetch: () => void;
}

function DeleteModal({ refetch }: DeleteModalProps) {
  const { id, isDeleting, setIsDeleting } = useModal();

  const { mutateAsync, isLoading } = useDeleteJobs();

  const handleDelete = async () => {
    const response = await mutateAsync(id!);

    if (response.status === 204) {
      showSuccess("Grupo de Jobs deletado com sucesso");
      setIsDeleting(false);
      refetch();
      return;
    }

    const details = (response as any).response.data.Details;
    const error = details[0].Errors[0];
    showError(error);
    setIsDeleting(false);
  };

  return (
    <CustomModal
      title="Excluir Grupo de Jobs"
      visible={isDeleting}
      onCancel={() => setIsDeleting(false)}
      maskClosable={false}
      footer={
        <>
          <Button
            disabled={isLoading}
            loading={isLoading}
            size="large"
            type="primary"
            danger
            onClick={handleDelete}
            style={{ borderRadius: 8 }}
          >
            Excluir
          </Button>
          <Button
            disabled={isLoading}
            size="large"
            type="primary"
            danger
            onClick={() => setIsDeleting(false)}
            style={{ borderRadius: 8 }}
          >
            Cancelar
          </Button>
        </>
      }
    >
      <p>Tem certeza que deseja excluir o grupo de jobs?</p>
    </CustomModal>
  );
}

export default DeleteModal;

const CustomModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #ff4d4f;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }
`;
